import React from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import Button from "@mui/material/Button";
import MDButton from "components/MDButton";

import Moment from "react-moment";
import DataTable from "examples/Tables/DataTable";
import EditPreparation from "../EditPreparation";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getDevice, putDevice } from "../../../api/devices";
import { setCurrentDevices } from "../../../redux/reducers/devicesReducer";
import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";
import { getOrder } from "../../../api/orders";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Info";
import { styled } from "@mui/material/styles";

export default function PreparationTable({ device, user }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  function removeWeeks(date, weekNumber) {
    var dat = new Date(date.valueOf());
    dat.setDate(dat.getDate() - 7 * weekNumber);
    return dat;
  }

  function addWeeks(date, weekNumber) {
    var dat = new Date(date.valueOf());
    dat.setDate(dat.getDate() + 7 * weekNumber);
    return dat;
  }

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  const dispatch = useDispatch();

  async function updateDeviceAPI(updatedDevice) {
    await putDevice(updatedDevice, device.device_id);
  }

  async function fetchOrder() {
    const response = await getOrder(currentOrder.order_id);
    dispatch(setCurrentOrder(response.data));
  }

  async function fetchDevice(deviceId) {
    const response = await getDevice(deviceId);
    return await response.data;
  }

  const fetchDevices = async () => {
    if (currentOrder) {
      if (currentOrder.devices_ids) {
        const devices = [];
        const devices_id = currentOrder.devices_ids.split(",");
        for (let i = 0; i < devices_id.length; i++) {
          devices.push(await fetchDevice(devices_id[i]));
        }

        // Sort the devices array based on the device identifier
        devices.sort((a, b) => {
          // Extract the base device identifier (ignoring anything after a hyphen)
          const baseIdA = a.device_number.split(" -")[0];
          const baseIdB = b.device_number.split(" -")[0];

          // Compare the base identifiers
          if (baseIdA < baseIdB) return -1;
          if (baseIdA > baseIdB) return 1;

          // If base identifiers are equal, compare the full device_id to maintain relative order
          return a.device_number.localeCompare(b.device_number);
        });

        dispatch(setCurrentDevices(devices));
      }
    }
  };

  async function submit(updatedDevice) {
    await updateDeviceAPI(updatedDevice);
    await fetchOrder();
    await fetchDevices();
  }

  const InfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "rgba(97, 97, 97, 0.92)",
      borderRadius: "4px",
      color: "#fff",
      padding: "4px 8px",
      fontSize: "0.802rem",
      maxWidth: "260px",
      margin: "0",
      wordWrap: "break-word",
      fontWeight: "500",
      position: "relative",
      "span.MuiTooltip-arrow": { color: "rgba(97, 97, 97, 0.92)" },
    },
  }));

  const preparationColumns = [
    {
      Header: "Statut appareil",
      accessor: "status",
      align: "center",
      info: "workers status",
      last: "preparation",
    },
    { Header: "Dates", accessor: "dates", align: "center", last: "preparation" },
    { Header: "Groupe WhatsApp", accessor: "group", align: "center", last: "preparation" },
    { Header: "Plans", accessor: "plans", align: "center", last: "preparation" },
    { Header: "Finitions cabine", accessor: "cabin", align: "center", last: "preparation" },
    { Header: "Sortie d'usine", accessor: "factory", align: "center", last: "preparation" },
    { Header: "Livraison sur site", accessor: "site", align: "center", last: "preparation" },
    { Header: "Début du montage", accessor: "assembly", align: "center", last: "preparation" },
    { Header: "MAD", accessor: "mad", align: "center", last: "preparation" },
  ];

  const preparationRows = [
    {
      dates: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          Contractuelles
        </MDTypography>
      ),
      group: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      plans: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      cabin: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      factory: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      site: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      assembly:
        device && device.assembly_start_contractual_date !== null ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Prévu le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device && device.assembly_start_contractual_date}
                </Moment>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 110 + "px" }}>
              <MDTypography display="block" color="error" variant="caption" fontWeight="medium">
                Date contractuelle non spécifiée
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      mad:
        device && device.mad_contractual_date !== null ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Prévue le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">{device && device.mad_contractual_date}</Moment>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 110 + "px" }}>
              <MDTypography display="block" color="error" variant="caption" fontWeight="medium">
                Date contractuelle non spécifiée
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
    },
    {
      dates: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          Planifiées
          <InfoTooltip
            placement="top"
            arrow
            title={
              <p
                style={{
                  margin: "0",
                  fontSize: "0.802rem !important",
                }}
              >
                Les dates planifiées sont calculées automatiquement à l'aide de la date
                contractuelle de début de montage (ou la date contractuelle de MAD), le délai
                fabrication appareil et la durée chantier (modifiables dans les informations de
                l'appareil).
              </p>
            }
          >
            <HelpIcon
              style={{
                marginTop: "0.3rem",
                marginLeft: "0.4rem", // space after the title
                fontSize: "1.3rem", // match with your design
                cursor: "pointer", // to show it's clickable
                verticalAlign: "top", // to align with the text
              }}
            />
          </InfoTooltip>
        </MDTypography>
      ),
      status: (
        <MDBox alignItems="center" lineHeight={1}>
          <MDBox lineHeight={1}>
            <MDBox ml={-1}>
              {device && device.status !== null ? (
                <MDBadge
                  badgeContent={device && device.status}
                  color="info"
                  variant="gradient"
                  size="lg"
                />
              ) : (
                <MDBadge
                  badgeContent="Non spécifié"
                  color={!darkMode ? "dark" : "light"}
                  variant="gradient"
                  size="lg"
                />
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      ),
      group: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          -
        </MDTypography>
      ),
      plans:
        device &&
        (((device.mad_contractual_date !== null || device.mad_provisional_date !== null) &&
          device.period !== null &&
          device.wait !== null) ||
          ((device.assembly_start_contractual_date !== null ||
            device.assembly_start_provisional_date !== null) &&
            device.wait !== null)) ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Planifiée le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device &&
                  (device.assembly_start_contractual_date || device.assembly_start_provisional_date)
                    ? removeWeeks(
                        device.assembly_start_provisional_date !== null
                          ? device.assembly_start_provisional_date
                          : device.assembly_start_contractual_date,
                        device.wait + 2
                      )
                    : removeWeeks(
                        device.mad_provisional_date !== null
                          ? device.mad_provisional_date
                          : device.mad_contractual_date,
                        device.period + device.wait + 2
                      )}
                </Moment>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 100 + "px" }}>
              <MDTypography display="block" color="warning" variant="caption" fontWeight="medium">
                Date planifiée non calculable
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      cabin:
        device &&
        (((device.mad_contractual_date !== null || device.mad_provisional_date !== null) &&
          device.period !== null &&
          device.wait !== null) ||
          ((device.assembly_start_contractual_date !== null ||
            device.assembly_start_provisional_date !== null) &&
            device.wait !== null)) ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Planifiée le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device &&
                  (device.assembly_start_contractual_date || device.assembly_start_provisional_date)
                    ? removeWeeks(
                        device.assembly_start_provisional_date !== null
                          ? device.assembly_start_provisional_date
                          : device.assembly_start_contractual_date,
                        device.wait + 2
                      )
                    : removeWeeks(
                        device.mad_provisional_date !== null
                          ? device.mad_provisional_date
                          : device.mad_contractual_date,
                        device.period + device.wait + 2
                      )}
                </Moment>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 100 + "px" }}>
              <MDTypography display="block" color="warning" variant="caption" fontWeight="medium">
                Date planifiée non calculable
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      factory:
        device &&
        (((device.mad_contractual_date !== null || device.mad_provisional_date !== null) &&
          device.period !== null) ||
          device.assembly_start_contractual_date !== null ||
          device.assembly_start_provisional_date !== null) ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Planifiée le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device &&
                  (device.assembly_start_contractual_date || device.assembly_start_provisional_date)
                    ? removeWeeks(
                        device.assembly_start_provisional_date !== null
                          ? device.assembly_start_provisional_date
                          : device.assembly_start_contractual_date,
                        2
                      )
                    : removeWeeks(
                        device.mad_provisional_date !== null
                          ? device.mad_provisional_date
                          : device.mad_contractual_date,
                        device.period + 2
                      )}
                </Moment>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 100 + "px" }}>
              <MDTypography display="block" color="warning" variant="caption" fontWeight="medium">
                Date planifiée non calculable
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      site:
        device &&
        (((device.mad_contractual_date !== null || device.mad_provisional_date !== null) &&
          device.period !== null) ||
          device.assembly_start_contractual_date !== null ||
          device.assembly_start_provisional_date !== null) ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Planifiée le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device &&
                  (device.assembly_start_contractual_date || device.assembly_start_provisional_date)
                    ? removeWeeks(
                        device.assembly_start_provisional_date !== null
                          ? device.assembly_start_provisional_date
                          : device.assembly_start_contractual_date,
                        1
                      )
                    : removeWeeks(
                        device.mad_provisional_date !== null
                          ? device.mad_provisional_date
                          : device.mad_contractual_date,
                        device.period + 1
                      )}
                </Moment>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 100 + "px" }}>
              <MDTypography display="block" color="warning" variant="caption" fontWeight="medium">
                Date planifiée non calculable
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      assembly:
        device &&
        (((device.mad_contractual_date !== null || device.mad_provisional_date !== null) &&
          device.period !== null) ||
          device.assembly_start_contractual_date !== null ||
          device.assembly_start_provisional_date !== null) ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Planifiée le</MDTypography>
              <MDTypography
                display="block"
                color={device && device.assembly_start_provisional_date !== null && "info"}
                variant="string"
                fontWeight="medium"
              >
                <Moment format="DD/MM/YYYY">
                  {device && device && device.assembly_start_provisional_date
                    ? device.assembly_start_provisional_date
                    : device.assembly_start_contractual_date
                    ? device.assembly_start_contractual_date
                    : removeWeeks(
                        device.mad_provisional_date !== null
                          ? device.mad_provisional_date
                          : device.mad_contractual_date,
                        device.period
                      )}
                </Moment>
              </MDTypography>
            </MDBox>
            {device && device.assembly_start_provisional_date && (
              <InfoTooltip
                placement="top"
                arrow
                title={
                  <p
                    style={{
                      margin: "0",
                      fontSize: "0.802rem !important",
                    }}
                  >
                    Date modifiée manuellement
                  </p>
                }
              >
                <HelpIcon
                  style={{
                    marginTop: "0.3rem",
                    marginLeft: "0.4rem", // space after the title
                    fontSize: "1.3rem", // match with your design
                    cursor: "pointer", // to show it's clickable
                    verticalAlign: "top", // to align with the text
                  }}
                />
              </InfoTooltip>
            )}
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 100 + "px" }}>
              <MDTypography display="block" color="warning" variant="caption" fontWeight="medium">
                Date planifiée non calculable
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      mad:
        device &&
        (device.mad_contractual_date !== null ||
          device.mad_provisional_date ||
          ((device.assembly_start_contractual_date !== null ||
            device.assembly_start_provisional_date !== null) &&
            device.period !== null)) ? (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography variant="caption">Planifiée le</MDTypography>
              <MDTypography
                display="block"
                color={device && device.mad_provisional_date !== null && "info"}
                variant="string"
                fontWeight="medium"
              >
                <Moment format="DD/MM/YYYY">
                  {device && device.mad_provisional_date
                    ? device.mad_provisional_date
                    : device.mad_contractual_date
                    ? device.mad_contractual_date
                    : addWeeks(
                        device.assembly_start_provisional_date !== null
                          ? device.assembly_start_provisional_date
                          : device.assembly_start_contractual_date,
                        device.period
                      )}
                </Moment>
              </MDTypography>
            </MDBox>
            {device && device.mad_provisional_date && (
              <InfoTooltip
                placement="top"
                arrow
                title={
                  <p
                    style={{
                      margin: "0",
                      fontSize: "0.802rem !important",
                    }}
                  >
                    Date modifiée manuellement
                  </p>
                }
              >
                <HelpIcon
                  style={{
                    marginTop: "0.3rem",
                    marginLeft: "0.4rem", // space after the title
                    fontSize: "1.3rem", // match with your design
                    cursor: "pointer", // to show it's clickable
                    verticalAlign: "top", // to align with the text
                  }}
                />
              </InfoTooltip>
            )}
          </MDBox>
        ) : (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%", maxWidth: 100 + "px" }}>
              <MDTypography display="block" color="warning" variant="caption" fontWeight="medium">
                Date planifiée non calculable
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
    },
    {
      dates: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          Réelles
        </MDTypography>
      ),
      group: (
        <>
          {device && device.group_creation_date !== null && (
            <MDBox
              display="flex"
              alignItems="center"
              sx={{ marginBottom: "0.2rem" }}
              lineHeight={1}
            >
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography variant="caption">Créé le</MDTypography>
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom: device && device.group_creation_date === null ? 0 : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  device.group_creation_date !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        group_creation_date:
                          device && device.group_creation_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      device.group_creation_date !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={device && device.group_creation_date === null ? "warning" : "success"}
                  >
                    {device && device.group_creation_date === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Créé
                      </MDTypography>
                    ) : (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        <Moment format="DD/MM/YYYY">{device && device.group_creation_date}</Moment>
                      </MDTypography>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
      plans: (
        <>
          {device && device.plan_validation_date !== null && (
            <MDBox
              display="flex"
              alignItems="center"
              sx={{ marginBottom: "0.2rem" }}
              lineHeight={1}
            >
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography variant="caption">Validés le</MDTypography>
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom: device && device.plan_validation_date === null ? 0 : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  device.plan_validation_date !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        plan_validation_date:
                          device && device.plan_validation_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      if (
                        device &&
                        device.plan_validation_date === null &&
                        device.cabin_validation_date !== null
                      ) {
                        deviceUpdates.status = "En cours de fabrication";
                      }
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      device.plan_validation_date !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={device && device.plan_validation_date === null ? "warning" : "success"}
                  >
                    {device && device.plan_validation_date === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Validés
                      </MDTypography>
                    ) : (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        <Moment format="DD/MM/YYYY">{device && device.plan_validation_date}</Moment>
                      </MDTypography>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
      cabin: (
        <>
          {device && device.cabin_validation_date !== null && (
            <MDBox
              display="flex"
              alignItems="center"
              sx={{ marginBottom: "0.2rem" }}
              lineHeight={1}
            >
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography variant="caption">Validées le</MDTypography>
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom: device && device.cabin_validation_date === null ? 0 : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  device.cabin_validation_date !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        cabin_validation_date:
                          device && device.cabin_validation_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      if (
                        device &&
                        device.cabin_validation_date === null &&
                        device.plan_validation_date !== null
                      ) {
                        deviceUpdates.status = "En cours de fabrication";
                      }
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      device.cabin_validation_date !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={device && device.cabin_validation_date === null ? "warning" : "success"}
                  >
                    {device && device.cabin_validation_date === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Validées
                      </MDTypography>
                    ) : (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        <Moment format="DD/MM/YYYY">
                          {device && device.cabin_validation_date}
                        </Moment>
                      </MDTypography>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
      factory: (
        <>
          {device && device.ex_factory_real_date !== null && (
            <MDBox
              display="flex"
              alignItems="center"
              sx={{ marginBottom: "0.2rem" }}
              lineHeight={1}
            >
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography variant="caption">Faite le</MDTypography>
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom: device && device.ex_factory_real_date === null ? 0 : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  device.ex_factory_real_date !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        ex_factory_real_date:
                          device && device.ex_factory_real_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      if (device && device.ex_factory_real_date === null) {
                        deviceUpdates.status = "À faire livrer";
                      }
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      device.ex_factory_real_date !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={device && device.ex_factory_real_date === null ? "warning" : "success"}
                  >
                    {device && device.ex_factory_real_date === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Faite
                      </MDTypography>
                    ) : (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        <Moment format="DD/MM/YYYY">{device && device.ex_factory_real_date}</Moment>
                      </MDTypography>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
      site: (
        <>
          {device &&
            (device.site_delivery_real_date !== null || device.ex_factory_real_date !== null) && (
              <MDBox
                display="flex"
                alignItems="center"
                sx={{ marginBottom: "0.2rem" }}
                lineHeight={1}
              >
                <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                  <MDTypography variant="caption">Faite le</MDTypography>
                </MDBox>
              </MDBox>
            )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom:
                  device &&
                  device.site_delivery_real_date === null &&
                  device.ex_factory_real_date === null
                    ? 0
                    : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  (device.site_delivery_real_date || device.ex_factory_real_date) !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        site_delivery_real_date:
                          device && device.site_delivery_real_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      if (device && device.site_delivery_real_date === null) {
                        deviceUpdates.status = "Montage";
                      }
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      (device.site_delivery_real_date || device.ex_factory_real_date) !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={
                      device &&
                      (device.site_delivery_real_date || device.ex_factory_real_date) === null
                        ? "warning"
                        : "success"
                    }
                  >
                    {device &&
                    (device.site_delivery_real_date || device.ex_factory_real_date) === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Faite
                      </MDTypography>
                    ) : (
                      <>
                        <MDTypography
                          color="white"
                          display="block"
                          variant="string"
                          fontWeight="medium"
                        >
                          <Moment format="DD/MM/YYYY">
                            {device && device.site_delivery_real_date
                              ? device.site_delivery_real_date
                              : addWeeks(device.ex_factory_real_date, 1)}
                          </Moment>
                        </MDTypography>
                        {device.site_delivery_real_date === null && (
                          <InfoTooltip
                            placement="top"
                            arrow
                            title={
                              <p
                                style={{
                                  margin: "0",
                                  fontSize: "0.802rem !important",
                                }}
                              >
                                Date calculée avec la date de sortie d'usine (NON ENREGISTRÉE)
                              </p>
                            }
                          >
                            <HelpIcon
                              style={{
                                marginTop: "0rem",
                                marginLeft: "0.4rem", // space after the title
                                fontSize: "1.3rem", // match with your design
                                cursor: "pointer", // to show it's clickable
                                verticalAlign: "top", // to align with the text
                              }}
                            />
                          </InfoTooltip>
                        )}
                      </>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
      assembly: (
        <>
          {device && device.assembly_start_real_date !== null && (
            <MDBox
              display="flex"
              alignItems="center"
              sx={{ marginBottom: "0.2rem" }}
              lineHeight={1}
            >
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography variant="caption">Fait le</MDTypography>
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom: device && device.assembly_start_real_date === null ? 0 : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  device.assembly_start_real_date !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        assembly_start_real_date:
                          device && device.assembly_start_real_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      device.assembly_start_real_date !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={
                      device && device.assembly_start_real_date === null ? "warning" : "success"
                    }
                  >
                    {device && device.assembly_start_real_date === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Fait
                      </MDTypography>
                    ) : (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        <Moment format="DD/MM/YYYY">
                          {device && device.assembly_start_real_date}
                        </Moment>
                      </MDTypography>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
      mad: (
        <>
          {device && device.mad_real_date !== null && (
            <MDBox
              display="flex"
              alignItems="center"
              sx={{ marginBottom: "0.2rem" }}
              lineHeight={1}
            >
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography variant="caption">Faite le</MDTypography>
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox
              lineHeight={1}
              sx={{
                textAlign: "center",
                width: "100%",
                marginBottom: device && device.mad_real_date === null ? 0 : "0.25rem",
              }}
            >
              <Tooltip
                title={
                  user &&
                  user.role !== "Admin" &&
                  user.role !== "Pilote" &&
                  device &&
                  device.mad_real_date !== null
                    ? "Votre rôle ne vous permet pas d'invalider cette date"
                    : ""
                }
                placement="top"
              >
                <div>
                  <MDButton
                    onClick={() => {
                      const deviceUpdates = {
                        mad_real_date:
                          device && device.mad_real_date === null
                            ? moment(new Date()).format("YYYY-MM-DD")
                            : null,
                      };
                      if (device && device.mad_real_date === null) {
                        deviceUpdates.status = "MAD";
                      }
                      submit(deviceUpdates);
                    }}
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      device.mad_real_date !== null
                        ? true
                        : false
                    }
                    size="small"
                    variant="contained"
                    color={device && device.mad_real_date === null ? "warning" : "success"}
                  >
                    {device && device.mad_real_date === null ? (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        Faite
                      </MDTypography>
                    ) : (
                      <MDTypography
                        color="white"
                        display="block"
                        variant="string"
                        fontWeight="medium"
                      >
                        <Moment format="DD/MM/YYYY">{device && device.mad_real_date}</Moment>
                      </MDTypography>
                    )}
                  </MDButton>
                </div>
              </Tooltip>
            </MDBox>
          </MDBox>
        </>
      ),
    },
  ];

  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "50%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Préparation du chantier
          </MDTypography>
          {user &&
            (user.role === "Contremaître" ||
              user.role === "Chef d'agence" ||
              user.role === "Admin" ||
              user.role === "Pilote") && (
              <Grid style={{ textAlign: "right", width: "50%" }}>
                <EditPreparation device={device} edit={true} renderStep={0} />
              </Grid>
            )}
        </MDBox>
        <MDBox pt={0.75} pl={0}>
          <DataTable
            table={{ columns: preparationColumns, rows: preparationRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
          <Grid item mt={0.5} mb={0.5} xs={12}>
            <Divider
              sx={{
                margin: "-0.25rem 0rem 0rem 0rem",
                opacity: 0.09,
                background: !darkMode ? "grey" : "#FFF",
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Grid
              sx={{
                padding: "12px !important",
              }}
            >
              <MDTypography
                component="a"
                sx={(theme) => ({
                  fontSize: "15px !important",
                  display: "block",
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                })}
                variant="button"
                fontWeight="medium"
              >
                <MDTypography variant="caption" fontSize={14}>
                  Commentaire de préparation :{" "}
                </MDTypography>
                {device && device.prepa_commentary !== null
                  ? device.prepa_commentary
                  : "Aucun commentaire"}
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </Grid>
  );
}
